import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { CreateJobTypeComponent} from './../create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { JobTypeLocation } from '../../../../shared/models/jobTypeLocation.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';


@Component({
  selector: 'app-create-location',
  templateUrl: './create-location.component.html',
  styleUrls: ['./create-location.component.css']
})
export class CreateLocationComponent implements OnInit, OnChanges {

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   // for report tools
@Input() job_type_name?;
@Input() job_type_id?;
@Input() job_type_location_name?;
@Input() job_type_location_id?;
@Input() job_type_court_name?;
@Input() job_type_court_id?;
@Input() job_type_document_type_name?;
@Input() job_type_document_type_id?;
  
  model: JobTypeLocation;
  job_types: any;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  get_latest_location_id: Object;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  // to preselect the drop downs
  @Input() sent_job_type_id: number;
  // job_type_id: any;
  selected_job_type_id: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
public gfunc: GlobalFunctionsService,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }

  ngOnInit() {
   


  }

      // check for changes. to load data. sent from Inputs
      ngOnChanges(changes) {
      
        if (changes.sent_job_type_id) {
          // deal with asynchronous Observable result
          this.selected_job_type_id = changes.sent_job_type_id.currentValue;
              // load data from sent ID
              // this.model = new JobTypeLocation();
              // this.getJobTypes();
        }

 // stops error on subjects page not having a job id initally
 if(this.job_type_id >= 1){

  this.model = new JobTypeLocation();  // this.model = new SubjectCommunication(); //SubjectTemplateDocs

  this.model.job_type_id = this.job_type_id;
  this.model.job_type_location_id = this.job_type_location_id;
  // this.model.job_type_court_id = this.job_type_court_id;
  // this.model.job_type_document_type_id = this.job_type_document_type_id as number; // for some reason no double quotes in json as it was converted to string somewhere olong the line



  setTimeout(() => {  
    console.log("A Simple Pause!"); 
    this.getJobTypes();
  //  this.getJobTypeLocations(this.job_type_id);
    console.log("Now Ready to load...");
  }, 900);

 }


      }


  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
   
   
   
    // this.count2 = job_type_id;
    // this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
  
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }



  createJobLocation(model) {
    // console.log(model);
        this._demoService.createJobLocation(model).subscribe(
             data => {  this.get_latest_location_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding loaction Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Location Added');
       };
 


}
